import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import { useCurrentSubscriptionQuery } from 'api';
import { useAuth } from 'hooks';

import { EmployeeFullDetails, EmployeeSimplifiedDetails } from '../';
import { ContentWrapper, PageW } from './styled';

export function EmployeeDetailPage(): ReactElement {
  useCurrentSubscriptionQuery();

  const { employeeId = '' } = useParams<string>();
  const { isManager, user: currentUser } = useAuth();

  const isProfileView = isManager || employeeId === currentUser?.id;

  return (
    <PageW>
      <ContentWrapper>
        {isProfileView ? (
          <EmployeeFullDetails employeeId={employeeId} />
        ) : (
          <EmployeeSimplifiedDetails />
        )}
      </ContentWrapper>
    </PageW>
  );
}
